import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { BackToTopProps } from './types/backToTop.types';
import { iconSize } from '../../../../constants/icon.constants';
import { windowService } from '../../../../utils/window.utils';
import Icon from '../../../@shared/icon';

const BackToTop: FC<BackToTopProps> = ({ field }) => {
  const scrollToTop = (): void => windowService().scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="back-to-top" onClick={scrollToTop}>
      <Text tag="p" field={field} className="back-to-top__text" />
      <button className="back-to-top__button" type="button">
        <Icon iconName="arrow-chevron-up" color="primary" size={iconSize.lg} />
      </button>
    </div>
  );
};

export default BackToTop;
